import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  color: ${({ theme }) => theme.colors.logo};
  font-size: 1rem;
  align-items: center;
  width: fit-content;

  span {
    padding: 0;
    margin: 0;
    line-height: 1rem;
    font-weight: 700;
    font-family: "KoHo";
  }
`;

export const AccentFont = styled.span`
  padding: 0;
  margin: 0;
  font-size: 1rem;
  line-height: 1rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.logoAccent};
  font-family: "KoHo";
`;

export const LogoImage = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
`;
